import { render, staticRenderFns } from "./Bien.vue?vue&type=template&id=c3c6e352&scoped=true&"
import script from "./Bien.vue?vue&type=script&lang=js&"
export * from "./Bien.vue?vue&type=script&lang=js&"
import style0 from "./Bien.vue?vue&type=style&index=0&id=c3c6e352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c6e352",
  null
  
)

export default component.exports